<template lang="html">

  <div class="banner-instagram">

    <h1 class="big-title container">
      <strong>Síguenos</strong>
      <span>#AJaénAlParaíso</span>
    </h1>

    <div class="bottom container row-between">
      <div class="images row-between">
        <img :src="igfeed[0].images.low_resolution.url" :alt="igfeed[0].caption.text" class="big">
        <div class="small-container row-between">
          <a :href="img.link" v-for="img in igfeed.slice(1,5)"><img :src="img.images.low_resolution.url" :alt="img.caption.text"></a>
        </div>
      </div>
      <div class="tags row-end">

        <a class="text" href="">#AJaénAtuParaíso</a>
        <a class="text" href="">#DestinoSeguro</a>
        <a class="link" href=""><i class="fa fa-instagram"></i></a>
        <a class="link" href=""><i class="fa fa-facebook"></i></a>

      </div>
    </div>

  </div>

</template>

<script lang="js">
  
  
    import {mapGetters} from 'vuex'
  
    export default  {
      name: 'ig-feed',
      computed:{
        ...mapGetters({
          igfeed : 'getIGFeed'
        })
      }
  }
  </script>


// WEBPACK FOOTER //
// src/components/parts/IG-integration.vue